module.exports = __webpack_public_path__ + "static/Impact_2_3-255903a9cd117fbba751f5ffc1aae6c0.svg";